import { useEffect } from 'react'

const useDisablePointerEventsWhenModalVisible = (isModalVisible: boolean) => {
  useEffect(() => {
    // The Drawer adds pointer-events to the body, which prevents any actions from being clickable
    // when the confirmation modal is opened.
    // https://github.com/emilkowalski/vaul/issues/492
    if (!isModalVisible) {
      return
    }

    const originalPointerEvents = document.body.style.pointerEvents

    const requestAnimation = window.requestAnimationFrame(() => {
      document.body.style.pointerEvents = 'auto'
    })

    return () => {
      window.cancelAnimationFrame(requestAnimation)
      document.body.style.pointerEvents = originalPointerEvents
    }
  }, [isModalVisible])
}

export default useDisablePointerEventsWhenModalVisible
